import React from 'react';
import { CheckIcon, PlusIcon } from 'lucide-react';
import { ServiceIcon } from './ServiceIcon';
import { services } from '../data/services';
import { images, site } from '../data/site';
type ServicesProps = {
  selected: string[];
  onToggle: (id: string) => void;
};
export function Services({
  selected,
  onToggle
}: ServicesProps) {
  return <section id="services" className="bg-canvas py-20 lg:py-28" data-id="element-296" data-mp="18uoblth2yx7c">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:px-8" data-id="element-297" data-mp="13w4rlym1rvhm">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-298" data-mp="z43eybkyw2r2">
          <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.95] text-ink lg:text-6xl" data-id="element-299" data-mp="u61o34hauz51">
            Common everyday <span className="text-brand" data-id="element-300" data-mp="q59da6ss4m6n">services</span>
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-ink-muted" data-id="element-301" data-mp="l5dhguu8k126">
            Here are just some of the many kinds of issues we handle. Tap <strong className="text-ink" data-id="element-302" data-mp="g7brrr2b13hq">Add</strong>{' '}
            on anything you need and we’ll bundle it into one free estimate.
          </p>
          <img src={images.flooring} alt="Technician installing new vinyl plank flooring" className="mt-8 hidden aspect-[4/3] w-full rounded-2xl object-cover lg:block" data-id="element-303" data-mp="36amvsk9x79qu" />
          <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-3" data-id="element-304" data-mp="32ami51unb2ku">
            <a href="#estimate" className="rounded-lg bg-ink px-6 py-3.5 font-display text-xl font-bold text-white transition-colors duration-150 hover:bg-ink-soft" data-id="element-305" data-mp="328i59uerqt8f">
              {selected.length > 0 ? `Get estimate for ${selected.length} item${selected.length > 1 ? 's' : ''}` : 'Start my estimate'}
            </a>
            <a href={site.phoneHref} className="font-display text-xl font-bold text-brand" data-id="element-306" data-mp="3l02kzvtsz74f">
              or call {site.phone}
            </a>
          </div>
        </div>

        <ul className="grid border-t border-line sm:grid-cols-2 sm:gap-x-10" data-id="element-307" data-mp="29mqflgieagg5">
          {services.map(service => {
          const isSelected = selected.includes(service.id);
          return <li key={service.id} className="flex gap-4 border-b border-line py-6" data-id="element-308" data-mp="1li8xp4cwzlva">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-white text-brand ring-1 ring-line" data-id="element-309" data-mp="1griqdlkxh8xy">
                  <ServiceIcon name={service.icon} className="h-6 w-6" data-id="element-310" data-mp="1brmr1zn6e5oq" />
                </span>
                <div className="flex min-w-0 flex-1 flex-col" data-id="element-311" data-mp="16unvdcnv5qof">
                  <div className="flex items-center gap-2" data-id="element-312" data-mp="11ui0zoq7lq2n">
                    <h3 className="font-display text-2xl font-bold leading-tight text-ink" data-id="element-313" data-mp="11syma2k7bn2z">{service.name}</h3>
                    {service.popular && <span className="rounded bg-brand-light px-1.5 py-0.5 text-[11px] font-bold text-brand-deep" data-id="element-314" data-mp="sud2k42zu20m">
                        Popular
                      </span>}
                  </div>
                  <p className="mt-1 text-[15px] leading-relaxed text-ink-muted" data-id="element-315" data-mp="2n8w7seex6jmc">{service.blurb}</p>
                  <button type="button" onClick={() => onToggle(service.id)} aria-pressed={isSelected} className={`mt-3 inline-flex w-fit items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-bold transition-colors duration-150 ${isSelected ? 'bg-brand text-white hover:bg-brand-dark' : 'bg-white text-ink ring-1 ring-line hover:ring-brand hover:text-brand'}`} data-id="element-316" data-mp="2uqcawtgq603x">
                    {isSelected ? <>
                        <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-317" data-mp="2lpe1twrfj2eh" /> Added to estimate
                      </> : <>
                        <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-318" data-mp="zexdx9lfbgm" /> Add to estimate
                      </>}
                  </button>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}